import React from 'react';

export default function CameraModal({
  showCameraModal,
  cameraFacingMode,
  toggleCameraLens,
  stopCamera,
  videoRef,
  overlayOpacity,
  setOverlayOpacity,
  capturePhoto
}) {
  if (!showCameraModal) return null;

  return (
    <div className="fixed inset-0 bg-black/95 z-50 flex flex-col items-center justify-between p-6 animate-fadeIn overflow-y-auto">
      <div className="w-full max-w-sm flex justify-between items-center py-2">
        <span className="text-[10px] text-white font-bold uppercase tracking-widest">CAPTURA PROGRESO</span>
        <div className="flex gap-2 items-center">
          <button onClick={toggleCameraLens} className="text-xs bg-white/20 text-white px-3 py-1.5 rounded-full font-bold uppercase tracking-wider">
            📷 {cameraFacingMode === 'environment' ? 'Trasera' : 'Frontal'}
          </button>
          <button onClick={stopCamera} className="text-gray-500 font-bold text-xl p-2">✕</button>
        </div>
      </div>

      <div className="relative w-full max-w-sm aspect-[3/4] bg-black rounded-[2rem] overflow-hidden border border-white/20 flex items-center justify-center my-auto shadow-2xl">
        <video ref={videoRef} autoPlay playsInline muted className="w-full h-full object-cover" />
        
        <div className="absolute inset-0 pointer-events-none flex items-center justify-center p-4 transition-opacity" style={{ opacity: overlayOpacity }}>
          <svg viewBox="0 0 100 200" className="w-full h-full stroke-white/80 fill-none" strokeWidth="0.8" strokeDasharray="2 1">
            <ellipse cx="50" cy="24" rx="8" ry="10" />
            <path d="M 46 34 L 54 34 M 47 34 L 47 38 M 53 38 L 53 34" />
            <path d="M 32 44 C 32 38, 68 38, 68 44 L 62 90 L 38 90 Z" />
            <path d="M 31 44 C 26 60, 25 80, 26 105" />
            <path d="M 69 44 C 74 60, 75 80, 74 105" />
            <path d="M 38 90 C 35 120, 36 150, 42 185" />
            <path d="M 62 90 C 65 120, 64 150, 58 185" />
            <line x1="50" y1="10" x2="50" y2="190" stroke="rgba(255,255,255,0.25)" strokeWidth="0.5" strokeDasharray="1 1" />
            <line x1="15" y1="90" x2="85" y2="90" stroke="rgba(255,255,255,0.25)" strokeWidth="0.5" strokeDasharray="1 1" />
          </svg>
        </div>
      </div>

      <div className="w-full max-w-sm space-y-2 py-4">
        <div className="flex justify-between text-[10px] font-bold text-gray-500 uppercase tracking-widest">
          <span>Opacidad Silueta:</span><span className="text-white">{Math.round(overlayOpacity * 100)}%</span>
        </div>
        <input type="range" min="0.1" max="1" step="0.1" value={overlayOpacity} onChange={(e) => setOverlayOpacity(parseFloat(e.target.value))} className="w-full accent-white" />
      </div>

      <button onClick={capturePhoto} className="w-full max-w-sm py-4 bg-white text-black font-black rounded-full text-[10px] uppercase tracking-widest shadow-lg mb-4">
        DISPARAR FOTO
      </button>
    </div>
  );
}